import { Button } from '@/components/ui/button';
import { Plus, Minus } from 'lucide-react';
import { useScreen } from 'usehooks-ts';

interface CartButtonProps {
  value?: number;
  onChange: (value: number) => void;

  addToCart: () => void;
}

export default function CartButton({ value, onChange, addToCart }: CartButtonProps) {
  const screen = useScreen();

  if (!value) {
    return (
      <button
        className="btn-lg bg-violet-500 text-gray-100 hover:bg-violet-700 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white my-0.5"
        onClick={addToCart}
      >
        Lägg till
      </button>
    );
  } else {
    return (
      <div className="inline-flex -space-x-px rounded-lg shadow-sm shadow-black/5 rtl:space-x-reverse justify-center">
        <Button
          className="rounded-none shadow-none first:rounded-s-lg last:rounded-e-lg focus-visible:z-10 py-6"
          variant="outline"
          size={screen.width > 420 ? 'default' : 'sm'}
          aria-label="Decrement"
          onClick={() => onChange(value - 1)}
        >
          <Minus size={16} strokeWidth={2} aria-hidden="true" />
        </Button>
        <span className="flex items-center border border-input text-lg font-medium w-full">
          <input
            type="text"
            className="w-full bg-transparent border-none text-center font-inherit outline-none appearance-none focus:ring-0 focus:ring-offset-0"
            value={value}
            readOnly={true}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const newValue = parseInt(event.target.value, 10);
              if (!isNaN(newValue)) {
                const clampedValue = Math.min(Math.max(newValue, 0), 50);
                onChange(clampedValue);
              } else {
                onChange(0);
              }
            }}
          />
        </span>

        <Button
          className="rounded-none shadow-none first:rounded-s-lg last:rounded-e-lg focus-visible:z-10 py-6"
          variant="outline"
          size={screen.width > 420 ? 'default' : 'sm'}
          aria-label="Increment"
          onClick={() => onChange(value + 1)}
        >
          <Plus size={16} strokeWidth={2} aria-hidden="true" />
        </Button>
      </div>
    );
  }
}
